import React from "react";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 px-6 md:px-12 py-10" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="text-xs tracking-[0.25em] uppercase text-[#9CA3AF]">
          © {new Date().getFullYear()} · Santiago Ramírez C. · Todos los derechos reservados
        </div>
        <div className="flex items-center gap-5">
          <a
            href="https://www.instagram.com/santiagovoice/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#F25C32] hover:text-[#D94E28] transition-colors"
            aria-label="Instagram"
            data-testid="footer-social-instagram"
          >
            <i className="fa-brands fa-instagram text-lg" />
          </a>
          <a
            href="https://www.linkedin.com/in/stgoramirez/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#F25C32] hover:text-[#D94E28] transition-colors"
            aria-label="LinkedIn"
            data-testid="footer-social-linkedin"
          >
            <i className="fa-brands fa-linkedin-in text-lg" />
          </a>
          <a
            href="mailto:hola@santiagovo.com"
            className="text-[#F25C32] hover:text-[#D94E28] transition-colors"
            aria-label="Email"
            data-testid="footer-social-email"
          >
            <i className="fa-solid fa-envelope text-lg" />
          </a>
        </div>
      </div>
    </footer>
  );
}
